import { Component, inject } from '@angular/core';
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import { MatButton } from "@angular/material/button";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ImageDialogData } from "../../../types/telegram-modal.types";
import { telegramImageModalName } from "./configs/telegram-image-config";

@Component({
  selector: 'app-telegram-image-modal',
  standalone: true,
    imports: [
        BaseModalComponent,
        MatButton
    ],
  templateUrl: './telegram-image-modal.component.html',
  styleUrl: './telegram-image-modal.component.scss'
})
export class TelegramImageModalComponent extends BaseModalComponent {
  public dialogData = inject<ImageDialogData>(MAT_DIALOG_DATA);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(telegramImageModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(telegramImageModalName);
  }
}
